interface ExtraDetailsProps {
    photographer: string
    sender: string
    mail: string
    phoneNumber: string
    validation: { mail: boolean, phoneNumber: boolean }
    onChange: (e: any) => void
    extraDetailsData: any
}

export class ExtraDetailsYnet extends React.Component<ExtraDetailsProps, State> {

    render() {
        const { photographer, sender, mail, phoneNumber, onChange, validation, extraDetailsData: { title, subTitle, mailPattern } } = this.props

        return (
            <div className="RedMailExtraDetails">
                {title && <div className="ExtraDetailsTitle">{title}</div>}
                {subTitle && <div className="ExtraDetailsSubTitle">{subTitle}</div>}

                <div className="inputFieldWrapper">
                    <div className="inputField">
                        <input name="sender" dir="rtl" value={sender} onChange={(e) => onChange(e)} type="text" id="sender" placeholder="שם השולח/ת" ></input>
                    </div>
                    <div className="inputField">
                        <input name="mail" dir="rtl" value={mail} onChange={(e) => onChange(e)} type="email" id="mail" placeholder="אימייל" ></input>
                        {(mail && !validation.mail) && <p className="redMail-error-validation">{mailPattern}</p>}
                    </div>
                    <div className="inputField">
                        <input name="phoneNumber" dir="rtl" value={phoneNumber} onChange={(e) => onChange(e)} type="text" id="phoneNumber" placeholder="טלפון" ></input>
                        {(phoneNumber && !validation.phoneNumber) && <p className="redMail-error-validation">המספר צריך להיות מורכב מ-10 ספרות ללא מקף</p>}
                    </div>
                    <div className="inputField">
                        <input name="photographer" dir="rtl" value={photographer} onChange={(e) => onChange(e)} type="text" id="photographer" placeholder="קרדיט לצלמ/ת" ></input>
                    </div>
                </div>
            </div>
        )
    }
}